import React from "react";
import {PaginationLinks} from "./PaginationLinks";
import {ForwardedPaginationToolbar} from "./PaginationToolbar";

export function Pagination(props) {
  const {
    children,
    isLoading,
    paginationProps,
    filterRef,
    countOptionPos = 'top',
    bottomAreaRef,
    hidePageList = false,
  } = props;
  return (
    <>
      {countOptionPos === 'top' && (
        <ForwardedPaginationToolbar
          isLoading={isLoading}
          hidePageList={hidePageList}
          paginationProps={paginationProps}
          ref={filterRef}
        />
      )}

      {children}

      <div className="d-flex justify-content-between align-items-center flex-wrap">
        <PaginationLinks paginationProps={paginationProps} />

        {countOptionPos === 'bottom' && (
          <ForwardedPaginationToolbar
            isLoading={isLoading}
            paginationProps={paginationProps}
            ref={filterRef}
          />
        )}

        {bottomAreaRef && (
          <div ref={bottomAreaRef} />
        )}
      </div>
    </>
  );
}
